import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iqac',
  templateUrl: './iqac.component.html',
  styleUrls: ['./iqac.component.scss']
})
export class IqacComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
